





















import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import UserInputForm from '@/components/user/organisms/UserInputForm.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'

@Component({
  components: { TcwLayoutBasicTemplate, UserInputForm }
})
export default class UserInputPage extends Mixins(BasePage) {
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected save(): void {
    this.form.startSaveProc()
  }
}
